/**
 * Created by dimah on 02/07/17.
 */

import { AbstractDTO } from "./abstract";

export class NewDTO extends AbstractDTO  {
    id: number;
    posted: string;
    title: string;
    summary: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = Number(attributes['id']) || 0;
        this.posted = attributes['posted'] || "";
        this.title = attributes['title'] || "";
        this.summary = attributes['summary'] || "";

    }

}
